import { usePage } from '@inertiajs/react';
import NavigateNextRoundedIcon from '@mui/icons-material/NavigateNextRounded';
import Breadcrumbs, { breadcrumbsClasses } from '@mui/material/Breadcrumbs';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import * as React from 'react';

const StyledBreadcrumbs = styled(Breadcrumbs)(({ theme }) => ({
  margin: theme.spacing(1, 0),
  [`& .${breadcrumbsClasses.separator}`]: {
    color: (theme.vars || theme).palette.action.disabled,
    margin: 1,
  },
  [`& .${breadcrumbsClasses.ol}`]: {
    alignItems: 'center',
  },
}));

// Mapeamento de rotas para breadcrumbs
const breadcrumbsMap = {
  '/users/sign_in': [
    { text: 'DriveSync', isActive: false },
    { text: 'Login', isActive: true }
  ],
  '/analytics': [
    { text: 'DriveSync', isActive: false },
    { text: 'Analytics', isActive: true }
  ],
  '/data_streams': [
    { text: 'DriveSync', isActive: false },
    { text: 'Analytics', isActive: false },
    { text: 'Planilhas', isActive: true }
  ],
  '/data_streams/new': [
    { text: 'DriveSync', isActive: false },
    { text: 'Analytics', isActive: false },
    { text: 'Planilhas', isActive: false },
    { text: 'Importar', isActive: true }
  ],
  '/towers': [
    { text: 'DriveSync', isActive: false },
    { text: 'Torre de Controle', isActive: true }
  ],
  '/locations': [
    { text: 'DriveSync', isActive: false },
    { text: 'Mapa', isActive: true }
  ],
  '/carriers': [
    { text: 'DriveSync', isActive: false },
    { text: 'Transportadoras', isActive: true }
  ],
  '/carriers/new': [
    { text: 'DriveSync', isActive: false },
    { text: 'Transportadoras', isActive: false },
    { text: 'Novo', isActive: true }
  ],
  '/users': [
    { text: 'DriveSync', isActive: false },
    { text: 'Usuários', isActive: true }
  ],
  '/users/new': [
    { text: 'DriveSync', isActive: false },
    { text: 'Usuários', isActive: false },
    { text: 'Novo', isActive: true }
  ],
  '/drivers': [
    { text: 'DriveSync', isActive: false },
    { text: 'Motoristas', isActive: true }
  ],
  '/drivers/new': [
    { text: 'DriveSync', isActive: false },
    { text: 'Motoristas', isActive: false },
    { text: 'Novo', isActive: true }
  ],
  '/trips': [
    { text: 'DriveSync', isActive: false },
    { text: 'Histórico', isActive: true }
  ],
  '/leads': [
    { text: 'DriveSync', isActive: false },
    { text: 'Leads', isActive: true }
  ]
};

// Breadcrumbs padrão para rotas não mapeadas
const defaultBreadcrumbs = [
  { text: 'DriveSync', isActive: false },
  { text: 'Dashboard', isActive: true }
];

export default function NavbarBreadcrumbs() {
  const { url } = usePage();

  // Obter breadcrumbs baseado na rota atual
  const getBreadcrumbs = () => {
    // Procura por correspondência exata primeiro
    if (breadcrumbsMap[url]) {
      return breadcrumbsMap[url];
    }

    // Verifica se é uma rota de edição (padrão: /entity/id/edit)
    if (url.includes('/edit')) {
      if (url.match(/^\/users\/\d+\/edit$/)) {
        return [
          { text: 'DriveSync', isActive: false },
          { text: 'Usuários', isActive: false },
          { text: 'Editar', isActive: true }
        ];
      }
      if (url.match(/^\/carriers\/\d+\/edit$/)) {
        return [
          { text: 'DriveSync', isActive: false },
          { text: 'Transportadoras', isActive: false },
          { text: 'Editar', isActive: true }
        ];
      }
      if (url.match(/^\/drivers\/\d+\/edit$/)) {
        return [
          { text: 'DriveSync', isActive: false },
          { text: 'Motoristas', isActive: false },
          { text: 'Editar', isActive: true }
        ];
      }
      if (url.match(/^\/trips\/\d+\/edit$/)) {
        return [
          { text: 'DriveSync', isActive: false },
          { text: 'Torre de Controle', isActive: false },
          { text: 'Editar Viagem', isActive: true }
        ];
      }
    }

    // Procura por correspondência parcial (para rotas dinâmicas)
    for (const [route, breadcrumbs] of Object.entries(breadcrumbsMap)) {
      if (url.startsWith(route) && route !== '/') {
        return breadcrumbs;
      }
    }

    // Retorna breadcrumbs padrão
    return defaultBreadcrumbs;
  };

  const breadcrumbs = getBreadcrumbs();

  return (
    <StyledBreadcrumbs
      aria-label="breadcrumb"
      separator={<NavigateNextRoundedIcon fontSize="small" />}
    >
      {breadcrumbs.map((crumb, index) => (
        <Typography
          key={index}
          variant="body1"
          sx={{
            color: crumb.isActive ? 'text.primary' : 'text.secondary',
            fontWeight: crumb.isActive ? 600 : 400
          }}
        >
          {crumb.text}
        </Typography>
      ))}
    </StyledBreadcrumbs>
  );
}
